import React from 'react'
import "./Second.css"

const Second = () => {
  return (
    <div>Second</div>
  )
}

export default Second